var _Fragment, _Fragment3, _Fragment4, _Fragment5;
import PropTypes from 'prop-types';
import React from 'react';
import { SubHeading, Text } from 'reaxl';
import SelectableInventorySnapshot from '../SelectableInventorySnapshot';
import { Fragment as _Fragment2, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function EmailAdditionalInventory(_ref) {
  let {
    additionalInventoryInfo = {},
    handleListingSelect = () => {}
  } = _ref;
  const additionalInventory = additionalInventoryInfo?.listings;
  if (!additionalInventory?.length) return null;
  const {
    hasSavedListings
  } = additionalInventoryInfo;
  return /*#__PURE__*/_jsxs(_Fragment2, {
    children: [/*#__PURE__*/_jsx(SubHeading, {
      className: "margin-bottom-3",
      size: 400,
      children: hasSavedListings ? _Fragment || (_Fragment = /*#__PURE__*/_jsx(_Fragment2, {
        children: "Follow Up On Your Saved Vehicles"
      })) : _Fragment3 || (_Fragment3 = /*#__PURE__*/_jsx(_Fragment2, {
        children: "Don't leave these vehicles in the dust!"
      }))
    }), /*#__PURE__*/_jsx(Text, {
      children: hasSavedListings ? _Fragment4 || (_Fragment4 = /*#__PURE__*/_jsx(_Fragment2, {
        children: "Let the sellers know you're still interested and confirm availability."
      })) : _Fragment5 || (_Fragment5 = /*#__PURE__*/_jsx(_Fragment2, {
        children: "Request more information."
      }))
    }), /*#__PURE__*/_jsx("div", {
      className: "margin-vertical-2",
      children: additionalInventory?.map(listing => /*#__PURE__*/_jsx("div", {
        className: "row",
        children: /*#__PURE__*/_jsx(SelectableInventorySnapshot, {
          listing: listing,
          onChange: e => handleListingSelect(e, listing)
        })
      }, `Selectableinventory_${listing.id}`))
    })]
  });
}
export default EmailAdditionalInventory;